import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {
  ConfiguratorAttributeCheckBoxComponent,
  ConfiguratorAttributeCompositionContext,
  ConfiguratorCommonsService,
} from '@spartacus/product-configurator/rulebased';
import {StepInputService, UdexEventTypeService} from '../../services';

@Component({
  selector: 'dcp-configurator-attribute-checkbox',
  templateUrl: './dcp-configurator-attribute-checkbox.component.html',
  styleUrls: ['./dcp-configurator-attribute-checkbox.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DcpConfiguratorAttributeCheckboxComponent
  extends ConfiguratorAttributeCheckBoxComponent
  implements OnInit
{
  checked: boolean = false;

  constructor(
    configuratorAttributeCompositionContext: ConfiguratorAttributeCompositionContext,
    configuratorCommonsService: ConfiguratorCommonsService,
    protected stepInputService: StepInputService,
    protected udexEventTypeService: UdexEventTypeService,
    private cdr: ChangeDetectorRef,
  ) {
    super(configuratorAttributeCompositionContext, configuratorCommonsService);
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.checked = this.attribute?.values?.[0].selected ?? false;
    this.cdr.markForCheck();
  }

  onAttributeChange(): void {
    this.attributeCheckBoxForm.patchValue(!this.attributeCheckBoxForm.value);
    this.checked = this.attributeCheckBoxForm.value;
    this.cdr.markForCheck();
    this.onSelect();
  }
}
